import { getAereosAutorizados, getAereosClaveViajeAutorizados } from "../services/serviceViaje";
import { FormatoFecha } from "./../utils/FormatFecha"
import { getDocuemtVoucherGrupalCompra } from "../services/documentosService";
const dataInicial = {
    aereos: [],
    total: 0,
    fechaInicio: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    fechaFinal: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    pagina: 0,
    registroPagina: 10,
    exito: 0,
    grupos: [],
    grupo: {},
    grupoValido: false,
}
const GET_AEREOS_AUTH_ALL = "GET_AEREOS_AUTH_ALL"
const GET_AEREOS_AUTH_BUSQUEDA_ALL = "GET_AEREOS_AUTH_BUSQUEDA_ALL"
const GET_AEREOS_AUTH_REGISTROS_PAGINA = "GET_AEREOS_AUTH_REGISTROS_PAGINA"
const GET_AEREOS_AUTH_PAGINA = "GET_AEREOS_AUTH_PAGINA"
const GET_AEREOS_AUTH_GRUPOS_CLAVE = "GET_AEREOS_AUTH_GRUPOS_CLAVE"
const GET_AEREOS_AUTH_DOWLOAD = "GET_AEREOS_AUTH_DOWLOAD"
const CLEAR_AEREOS_AUTH_STATE = "CLEAR_AEREOS_AUTH_STATE"
export default function aereosAutorizadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_AEREOS_AUTH_DOWLOAD:
            return {
                ...state,
                exito: action.payload.exito
            }
        case GET_AEREOS_AUTH_GRUPOS_CLAVE:
            return {
                ...state,
                grupos: action.payload.grupos,
                grupo: action.payload.grupo,
                grupoValido: action.payload.grupoValido,
            }
        case GET_AEREOS_AUTH_PAGINA:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_AEREOS_AUTH_REGISTROS_PAGINA:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_AEREOS_AUTH_BUSQUEDA_ALL:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                fechaInicio: action.payload.fechaInicio,
                fechaFinal: action.payload.fechaFinal,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case GET_AEREOS_AUTH_ALL:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total
            };
        case CLEAR_AEREOS_AUTH_STATE:
            return {
                ...state,
                aereos: action.payload.aereos
            }
        default:
            return state;
    }
}
export const obtenerVoucherDowloadGrupoAuthAction = ({idPagoGrupal}) => async (dispatch, getSate) => {
    return await getDocuemtVoucherGrupalCompra({idPagoGrupal}).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obteneraereosAuthAction = () => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina, registroPagina } = getSate().aereosAuth
    return await getAereosAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_ALL,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obteneraereosAuthBusquedaAction = ({ FechaInicio, FechaFin }) => async (dispatch, getSate) => {
    return await getAereosAutorizados({ FechaInicio, FechaFin ,Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_BUSQUEDA_ALL,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                fechaInicio: FechaInicio,
                fechaFinal: FechaFin,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obteneraereosAuthRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina } = getSate().aereosAuth
    return await getAereosAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_REGISTROS_PAGINA,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obteneraereosAuthPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, registroPagina } = getSate().aereosAuth
    return await getAereosAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_PAGINA,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerGruposClaveViajeAuthAction = ({ IdPagoGrupal }) => async (dispatch, getSate) => {
    return await getAereosClaveViajeAutorizados({ IdPagoGrupal }).then(Response => {
        dispatch({
            type: GET_AEREOS_AUTH_GRUPOS_CLAVE,
            payload: {
                grupos: Response,
                grupoValido: !Response.every(element => element?.Compra?.estatusCompra?.idEstatusCompra === 3),
                grupo: { ...Response, FechaViaje: Response.Fecha_Viaje, PlazaAereo: Response.totalCumplido, PlazaTotal: Response.totalPlazas, lViajeVompra: [] }
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}

export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_AEREOS_AUTH_STATE,
        payload: {
            dataInicial,
        },
    });
}